import React, { Component } from 'react';
import TabsComponent from './TabsComponent';

class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: props.tabs[0].id,
    };

    this.handleOnClickTab = this.handleOnClickTab.bind(this);
  }

  handleOnClickTab(event) {
    const { tabId } = event.currentTarget.dataset;

    this.setState({
      selected: tabId,
    });
  }

  render() {
    const { tabs, orientation } = this.props;
    const { selected } = this.state;

    return (
      <TabsComponent tabs={tabs} selected={selected} orientation={orientation} onClickTab={this.handleOnClickTab} />
    );
  }
}

export default Tabs;
